import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select, DatePicker, Button, Form, Input, Row, Col, Card, Checkbox } from 'antd';
import moment from 'moment';
import { buildApiUrl } from '../config/api';
import '../styles/Common.css'; // 공통 스타일

const { Option } = Select;
const { TextArea } = Input;

const ProductInfo = () => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [selectedDate, setSelectedDate] = useState(moment());  // 초기값으로 오늘 날짜 설정
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    // API에서 데이터 가져오기
    const fetchData = async () => {
      try {
        const response = await axios.get(buildApiUrl('/api/partname'));
        setOptions(response.data);
      } catch (error) {
        console.error('There was an error fetching the part names!', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // 선택된 옵션과 날짜가 모두 설정되면 버튼 활성화
    if (selectedOption && selectedDate) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [selectedOption, selectedDate]);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSubmit = () => {
    const payload = {
      partName: selectedOption,
      date: selectedDate.format('YYYY-MM-DD')
    };

    console.log('Sending payload:', payload);

    axios.post(buildApiUrl('/api/SearchPlan'), payload)
      .then(response => {
        console.log('Data fetched successfully:', response.data);
        setFormData(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  };

  return (
    <div className="common-container">
      <h1>생산 정보</h1>
      <div className="responsive-row">
        <div style={{ flex: 1, minWidth: '200px', marginBottom: '20px' }}>
          <Select
            value={selectedOption}
            onChange={handleOptionChange}
            style={{ width: '100%' }}
            placeholder="파트를 선택하세요"
          >
            {options.map((option, index) => (
              <Option key={index} value={option.partNameEng}>{option.partNameKor}</Option>
            ))}
          </Select>
        </div>
        <div style={{ flex: 1, minWidth: '200px', marginBottom: '20px' }}>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            style={{ width: '100%' }}
            placeholder="날짜를 선택하세요"
            format="YYYY-MM-DD"
          />
        </div>
      </div>
      <Button 
        type="primary" 
        onClick={handleSubmit} 
        disabled={isButtonDisabled}
        style={{ marginTop: '20px' }}
      >
        검색
      </Button>

      {formData && (
        <Card style={{ marginTop: '20px' }}>
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <h2>파트 이름</h2>
              </Col>
              <Col span={12}>
                <Form.Item label="생산 수량">
                  <Input value={formData.productionQuantity}/>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>

            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="완성창 발주량">
                  <Input value={formData.completeOrderQuantity}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="계획 수량">
                  <Input value={formData.planQuantity} readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="생산 인원">
                  <Input value={formData.productionPersonnel} readOnly />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="총 수량">
                  <Input value={formData.totalQuantity} readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="특이 사항">
                  <TextArea rows={4} value={formData.specialNotes} readOnly />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item>
                  <Checkbox checked={formData.isChecked} disabled>체크</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      )}
    </div>
  );
};

export default ProductInfo;
